// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-config.panel {
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #f5f7fa, #DBDCDD);
}

.row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

label {
  font-weight: bold;
  color: #333;
}

span {
  display: block;
  font-size: 16px;
  color: #555;
}

.project-completed {
  display: flex;
  align-items: center;
}

.project-completed label {
  margin-right: 10px;
}

.card {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.btn-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

/* Buttons */
.btn-primary {
  background: #0B2D71 !important; /* Primary blue background */
  color: #fff !important; /* Ensure white text */
  border: none !important; /* No border */
  border-radius: 0 !important; /* Square corners */
  font-family: "GothamBold", "Helvetica Neue", "Helvetica", "Arial", "sans-serif" !important; /* Font family */
  font-size: 0.88em !important; /* Font size */
  cursor: pointer !important; /* Pointer cursor */
}

.btn-primary:hover {
  background: #0066B2 !important; /* Darker blue on hover */
  color: #fff !important; /* Ensure white text on hover */
}

.list-sub-item {
  display: block;
  font-weight: bold;
  color: #333;
}

.highlight {
  background-color: #f9f9f9;
}

tr:hover {
  background-color: #330aea;
  color: white;
}

td, th {
  border: 1px solid #ddd;
  padding: 8px;
}

:host ::ng-deep .custom-save-button {
  all: unset; /* Reset all PrimeNG styles */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #0066B2 !important; /* Primary blue background */
  color: #fff !important; /* White text */
  border: none !important; /* No border */
  padding: 10px 20px !important; /* Add padding */
  font-family: "GothamBold", "Helvetica Neue", "Helvetica", "Arial", "sans-serif" !important; /* Font family */
  font-size: 14px !important; /* Font size */
  cursor: pointer !important; /* Pointer cursor */
  transition: background 0.3s ease, transform 0.2s ease !important; /* Smooth hover and transform effects */
}

:host ::ng-deep .custom-save-button:hover {
  background: #0B2D71 !important; /* Darker blue on hover */
  color: #fff !important; /* Ensure white text on hover */
}

:host ::ng-deep .custom-save-button:disabled {
  background: #0B2D71 !important; /* Gray background for disabled state */
  color: #6c757d !important; /* Muted text color */
  cursor: not-allowed !important; /* Disabled cursor */
  box-shadow: none !important; /* Remove shadow for disabled state */
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/projects/projects.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,qDAAA;AACF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AACA;EACE,iBAAA;EACA,WAAA;AAEF;;AAAA;EACE,cAAA;EACA,eAAA;EACA,WAAA;AAGF;;AADA;EACE,aAAA;EACA,mBAAA;AAIF;;AADA;EACE,kBAAA;AAIF;;AADA;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;AAIF;;AAAA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AAGF;;AADA,YAAA;AACA;EACE,8BAAA,EAAA,4BAAA;EACA,sBAAA,EAAA,sBAAA;EACA,uBAAA,EAAA,cAAA;EACA,2BAAA,EAAA,mBAAA;EACA,0FAAA,EAAA,gBAAA;EACA,4BAAA,EAAA,cAAA;EACA,0BAAA,EAAA,mBAAA;AAIF;;AADA;EACE,8BAAA,EAAA,yBAAA;EACA,sBAAA,EAAA,+BAAA;AAIF;;AAGA;EAAiB,cAAA;EAAgB,iBAAA;EAAmB,WAAA;AAGpD;;AAAA;EACE,yBAAA;AAGF;;AAAA;EACE,yBAAA;EACA,YAAA;AAGF;;AADC;EACC,sBAAA;EACA,YAAA;AAIF;;AAFA;EACE,UAAA,EAAA,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA,EAAA,4BAAA;EACA,sBAAA,EAAA,eAAA;EACA,uBAAA,EAAA,cAAA;EAEA,6BAAA,EAAA,gBAAA;EACA,0FAAA,EAAA,gBAAA;EACA,0BAAA,EAAA,cAAA;EACA,0BAAA,EAAA,mBAAA;EACA,gEAAA,EAAA,uCAAA;AAIF;;AADA;EACE,8BAAA,EAAA,yBAAA;EACA,sBAAA,EAAA,+BAAA;AAIF;;AACA;EACE,8BAAA,EAAA,uCAAA;EACA,yBAAA,EAAA,qBAAA;EACA,8BAAA,EAAA,oBAAA;EACA,2BAAA,EAAA,qCAAA;AAEF","sourcesContent":[".project-config.panel {\r\n  border: 1px solid #ddd;\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  box-shadow: 0 6px 12px rgba(0,0,0,0.1);\r\n  background: linear-gradient(135deg, #f5f7fa, #DBDCDD);\r\n}\r\n.row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-bottom: 15px;\r\n}\r\n\r\nlabel {\r\n  font-weight: bold;\r\n  color: #333;\r\n}\r\nspan {\r\n  display: block;\r\n  font-size: 16px;\r\n  color: #555;\r\n}\r\n.project-completed {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.project-completed label {\r\n  margin-right: 10px;\r\n}\r\n\r\n.card {\r\n  border: 1px solid #ccc;\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\r\n}\r\n\r\n\r\n.btn-container {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: 20px;\r\n}\r\n/* Buttons */\r\n.btn-primary {\r\n  background: #0B2D71 !important; /* Primary blue background */\r\n  color: #fff !important; /* Ensure white text */\r\n  border: none !important; /* No border */\r\n  border-radius: 0 !important; /* Square corners */\r\n  font-family: 'GothamBold', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif' !important; /* Font family */\r\n  font-size: 0.88em !important; /* Font size */\r\n  cursor: pointer !important; /* Pointer cursor */\r\n}\r\n\r\n.btn-primary:hover {\r\n  background: #0066B2 !important; /* Darker blue on hover */\r\n  color: #fff !important; /* Ensure white text on hover */\r\n}\r\n\r\n// .btn-primary:active {\r\n//   box-shadow: 0 2px #0056b3, 0 0 15px 3px rgba(0, 123, 255, 0.7);\r\n// }\r\n\r\n.list-sub-item { display: block; font-weight: bold; color: #333; }\r\n\r\n//table desing\r\n.highlight {\r\n  background-color: #f9f9f9;\r\n}\r\n\r\ntr:hover {\r\n  background-color: #330aea;\r\n  color: white;\r\n}\r\n td,  th {\r\n  border: 1px solid #ddd;\r\n  padding: 8px;\r\n}\r\n:host ::ng-deep .custom-save-button {\r\n  all: unset; /* Reset all PrimeNG styles */\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #0066B2 !important; /* Primary blue background */\r\n  color: #fff !important; /* White text */\r\n  border: none !important; /* No border */\r\n  //border-radius: 4px !important; /* Rounded corners */\r\n  padding: 10px 20px !important; /* Add padding */\r\n  font-family: 'GothamBold', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif' !important; /* Font family */\r\n  font-size: 14px !important; /* Font size */\r\n  cursor: pointer !important; /* Pointer cursor */\r\n  transition: background 0.3s ease, transform 0.2s ease !important; /* Smooth hover and transform effects */\r\n}\r\n\r\n:host ::ng-deep .custom-save-button:hover {\r\n  background: #0B2D71 !important; /* Darker blue on hover */\r\n  color: #fff !important; /* Ensure white text on hover */\r\n  //transform: translateY(-2px) !important; /* Slight lift effect on hover */\r\n  //box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important; /* Add shadow on hover */\r\n}\r\n\r\n:host ::ng-deep .custom-save-button:disabled {\r\n  background: #0B2D71 !important; /* Gray background for disabled state */\r\n  color: #6c757d !important; /* Muted text color */\r\n  cursor: not-allowed !important; /* Disabled cursor */\r\n  box-shadow: none !important; /* Remove shadow for disabled state */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
